import { Field } from 'formik';
import Select from 'react-select';

export default function PatientDependentDetails({ errors, touched, handleBlur, handleChange, handleGenderChange, values }) {

    const genderOptions = [
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' },
        { value: 'not-disclosed', label: 'Prefer not to disclose' }
    ];

    return (
        <div className="space-y-4">

            <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                <div className="md:col-span-5 space-y-2">
                    <label htmlFor="deptFirstname" className="block text-sm font-medium text-gray-700">First Name <span className="text-red-500">*</span></label>
                    <Field name="deptFirstname"
                        aria-label="Firstname"
                        aria-describedby="basic-addon1"
                        readOnly={false}
                        onBlur={handleBlur}
                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${errors.deptFirstname && touched.deptFirstname ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.deptFirstname && touched.deptFirstname ? (
                        <p className="text-red-500 text-sm mt-1">{errors.deptFirstname}</p>
                    ) : null}
                </div>
                <div className="md:col-span-2"></div>
                <div className="md:col-span-5 space-y-2">
                    <label htmlFor="deptLastname" className="block text-sm font-medium text-gray-700">Last Name <span className="text-red-500">*</span></label>
                    <Field name="deptLastname"
                        aria-label="Lastname"
                        aria-describedby="basic-addon1"
                        readOnly={false}
                        onBlur={handleBlur}
                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${errors.deptLastname && touched.deptLastname ? 'border-red-500' : 'border-gray-300'}`}
                    />
                    {errors.deptLastname && touched.deptLastname ? (
                        <p className="text-red-500 text-sm mt-1">{errors.deptLastname}</p>
                    ) : null}
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                <div className="md:col-span-5 space-y-2">
                    <label htmlFor="gender" className='block text-sm font-medium text-gray-700'>Gender <span className="text-red-500">*</span></label>
                    <Select
                        name="deptGender"
                        options={genderOptions}
                        value={genderOptions.find(option => option.value === values?.deptGender) || null}
                        onChange={(selectedOption) => {
                            const value = selectedOption ? selectedOption.value : "";
                            handleGenderChange(value);
                        }}
                        onBlur={() => handleBlur({ target: { name: "deptGender" } })}
                        placeholder="Please select"
                        className={`
                            ${errors.deptGender && touched.deptGender
                                ? 'border-red-500 rounded-md' 
                                : ''
                            }
                        `}
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: errors.deptGender && touched.deptGender
                                    ? '#ef4444' 
                                    : state.isFocused 
                                        ? '#14b8a6' 
                                        : '#d1d5db',
                                '&:hover': {
                                    borderColor: errors.deptGender && touched.deptGender
                                        ? '#ef4444' 
                                        : '#14b8a6',
                                },
                                boxShadow: state.isFocused 
                                    ? '0 0 0 3px rgba(20, 184, 166, 0.1)' 
                                    : 'none',
                                borderRadius: '0.375rem',
                            })
                        }}
                    />
                    {errors.deptGender && touched.deptGender ? (
                        <p className="text-red-500 text-sm mt-1">{errors.deptGender}</p>
                    ) : null}
                </div>
                <div className="md:col-span-2"></div>
                <div className="md:col-span-5 space-y-2">
                    <div className="space-y-2">
                        <label htmlFor="age" className='block text-sm font-medium text-gray-700'>Age <span className="text-red-500">*</span></label>
                        <div className="space-y-2">
                            <Field type="text" id={'dept_age'} name="deptAge"
                                onBlur={handleBlur}
                                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${errors.deptAge && touched.deptAge ? 'border-red-500' : 'border-gray-300'}`} />
                            {errors.deptAge && touched.deptAge ? (
                                <p className="text-red-500 text-sm mt-1">{errors.deptAge}</p>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}